// import axios from 'axios'
import $axios from '../static/js/request'
import { getAliVideoUrl } from './aliVideo'
import store from '../store'
const WECHAT_APP_ID = process.env.VUE_APP_appid
const isHttpUrl = (url) => url.indexOf('http') > -1
/**
 * HOC，用于增加处理过程
 * @param {*} fn 待处理函数
 */
function dealInfomationFlowData(fn) {
  return (...args) => {
    return (
      fn
        .apply(this, args)
        // 格式化收藏，点赞数据
        .then((res) => {
          // 列表数据
          if (res.pageable) {
            const { content, first, last, number } = res
            return {
              list: content.map((item) => formmatFIDataItem(item)),
              first,
              last,
              number
            }
            // 单个数据
          } else {

            return formmatFIDataItem(res)
          }
        })
        // 添加视频链接数据
        .then(async function(data) {
          const midData = data.list || [data]
          const videoPath = midData
            .filter((i) => i.type === 4 && !isHttpUrl(i.videoPath))
            .map((i) => i.videoPath)
          let videoPathObj = {}
          if (videoPath.length > 0) {
            videoPathObj = await getAliVideoUrl({
              ids: videoPath.join(',')
            })
          }
          // 遍历，直接改变原对象,此时的cover已经是urls
          midData.forEach((item) => {
            if (item.type === 4) {
              // 视频链接是http链接
              if (isHttpUrl(item.videoPath)) {
                item.video = {
                  src: item.videoPath,
                  cover: item.urls[0]
                }
                // 非http链接，即为阿里视频id
              } else {
                const aliVideo = videoPathObj[item.videoPath]
                // 有可能是错误的id
                if (aliVideo.success) {
                  item.video = {
                    src: aliVideo.data.playInfoList[0].playURL,
                    cover: item.urls[0] || aliVideo.data.videoBase.coverURL
                  }
                } else {
                  item.video = {}
                }
              }
            }
          })
          return data
        })
        .then(async function(data) {
          const midData = data.list || [data]
          const dictionaryData = await store.dispatch('dictionary/getDictionaryData', [
            'cmsData.homeArticle.classify'
          ])
          const classify = dictionaryData['cmsData.homeArticle.classify']
          midData.forEach((i) => {
            i.category = '#' + classify.find((t) => t.value === i.category).chName + '#'
          })
          return data
        })
        .then((data) => {

          return data
        })
    )
  }
}

/**
 * 给一个信息点赞
 * @param {Object} { openid, id: 信息流的id }
 */
export const giveALikeByIFItemId = ({ openid, id, appid = WECHAT_APP_ID }) => {
  const paramsStr = mapKeys2QueryString({
    openid,
    informationFlowId: String(id),
    appid
  })
  return $axios
    .post(`/mopa/api-answer-card/open/information/giveALike?${paramsStr}`)
    .then((data) => data.data)
}

/**
 * 给一个信息收藏
 * @param {Object} { openid, id: 信息流的id }
 */
export const giveCollectByIFItemId = ({ openid, id, appid = WECHAT_APP_ID }) => {
  const paramsStr = mapKeys2QueryString({
    openid,
    informationFlowId: String(id),
    appid
  })
  return $axios
    .post(`/mopa/api-answer-card/open/information/collect?${paramsStr}`)
    .then((data) => data.data)
}

/**
 * 给一个信息阅读
 * @param {Object} { openid, id: 信息流的id }
 */
export const readedInformation = ({ openid, id, appid = WECHAT_APP_ID }) => {
  const paramsStr = mapKeys2QueryString({
    openid,
    informationFlowId: String(id),
    appid
  })
  return $axios
    .post(`/mopa/api-answer-card/open/information/read?${paramsStr}`)
    .then((data) => data.data)
}

/**
 * 获取信息流列表，返回变换后的对象结构
 * @param {*} { openid }
 * @returns {Object} {list: []...}
 */
export const getInfomationFlowData = dealInfomationFlowData(
  ({ openid, page = 0, size, grade, search, search_EQ_deleted = 'N', appid = WECHAT_APP_ID }) => {
    const paramsStr = mapKeys2QueryString({
      openid,
      page,
      appid,
      size,
      search_LIKE_grade: grade,
      ...search
      // search_EQ_deleted
    })
    return $axios
      .get(`/mopa/api-answer-card/open/information/page?${paramsStr}`)
      .then((res) => res.data.data)
  }
)

/**
 * 获取信息流列表，返回变换后的对象结构
 * @param {*} { openid }
 * @returns {Object} {list: []...}
 */
export const getInfomationFlowItemData = dealInfomationFlowData(
  ({ openid, id, appid = WECHAT_APP_ID }) => {
    const paramsStr = mapKeys2QueryString({
      openid,
      id,
      appid
    })
    return $axios
      .post(`/mopa/api-answer-card/open/information/findById?${paramsStr}`)
      .then((res) => res.data.data)
  }
)
/**
 * 搜索信息流列表，返回变换后的对象结构
 * @param {*} { openid }
 * @returns {Object} {list: []...}
 */
export const searchInfomationFlowData = dealInfomationFlowData(
  ({ openid, page = 0, size, grade, search, appid = WECHAT_APP_ID }) => {
    const paramsStr = mapKeys2QueryString({
      openid,
      page,
      appid,
      size,
      grade,
      search
    })
    return $axios
      .get(`/mopa/api-answer-card/open/information/search?${paramsStr}`)
      .then((res) => res.data.data)
  }
)
/**
 * 个人中心获取收藏list返回变换后的对象结构 type
 * @param {*} { openid type: likes:点赞，collects：收藏，read：阅读}
 * @returns {Object} {list: []...}
 */
export const getCollectFlowData = dealInfomationFlowData(
  ({ openid, page = 0, size, type, appid = WECHAT_APP_ID }) => {
    const paramsStr = mapKeys2QueryString({
      openid,
      page,
      appid,
      size,
      type
    })
    return $axios
      .get(`/mopa/api-answer-card/open/information/findRelations?${paramsStr}`)
      .then((res) => {
        res.data.data.content = res.data.data.content.map((i) => ({ ...i, ...i.informationFlow }))
        return res.data.data
      })
  }
)
/**
 * 将返回的数据转换成前端所需要结构
 * @param {Object} item informationItem
 */
function formmatFIDataItem(item, collect) {
  //  category, sort,type,grade,remark,coverType, videoPath, status, creator,updater,
  //  updateTime, deleted, collectNum, isCollect
  // collect 是否是收藏列表 收藏list不展示置顶
  const {
    id,
    title,
    content,
    category,
    cover,
    type,
    coverType,
    createTime,
    updateTime,
    isLike,
    readNum,
    likeNum,
    topping,
    collectNum,
    isCollect,
    videoPath, // 直播课链接
    needAdPrint // 广告是否是外部的
  } = item
  const urls = cover.split(',').filter(Boolean)
  return {
    id: Number(id),
    category,
    content: {
      ready: false,
      title,
      html: content
    },
    coverType: Number(coverType),
    description: type === '2' ? content : title,
    urls,
    type: Number(type),
    top: topping === '1' && !collect,
    createTime: formmatTimeString2Date(createTime),
    updateTime: formmatTimeString2Date(updateTime),
    // time: new Date(2020, 6, 11),
    good: {
      number: likeNum,
      clicked: isLike
    },
    collect: {
      number: collectNum,
      clicked: isCollect
    },
    pv: readNum,
    videoPath,
    needAdPrint
  }
}

function mapKeys2QueryString(obj) {
  var str = ''
  for (const key in obj) {
    if (obj[key] || obj[key] >= 0) {
      str += `${key}=${obj[key]}&`
    }
  }
  return str.slice(0, -1)
}

/**
 *
 * @param {String} '2020-10-01'
 */
function formmatTimeString2Date(str) {
  if (typeof str !== 'string') return false
  return new Date(str.replace(/-/g, '/'))
}
